"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FullScreenFilterToggle = exports.FullScreenFilter = void 0;

var _baseReactComponents = require("@navinc/base-react-components");

var _filterCategory = require("./filter-category.js");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _screen = require("./screen.js");

var _filterIterator = require("../common/filter-iterator");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ToggleCopy = (0, _styledComponents["default"])(_baseReactComponents.Copy).withConfig({
  displayName: "ToggleCopy",
  componentId: "sc-4j5vy9-0"
})(["color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.bubbleBlue500;
});

var Toggle = _styledComponents["default"].div.withConfig({
  displayName: "Toggle",
  componentId: "sc-4j5vy9-1"
})(["width:100%;display:", ";flex-direction:row;align-items:center;justify-content:space-between;background-color:", ";padding:16px 48px;box-sizing:border-box;@media screen and (", "){display:", ";}& > ", "{flex:0 0 auto;}& > ", "{flex:1 0 0;margin-left:8px;}"], function (_ref2) {
  var forScreenSize = _ref2.forScreenSize;
  return forScreenSize === 'mobile' || forScreenSize === 'all' ? 'flex' : 'none';
}, function (_ref3) {
  var bubbleBlue200 = _ref3.theme.bubbleBlue200;
  return bubbleBlue200;
}, function (_ref4) {
  var forLargerThanPhone = _ref4.theme.forLargerThanPhone;
  return forLargerThanPhone;
}, function (_ref5) {
  var forScreenSize = _ref5.forScreenSize;
  return forScreenSize === 'desktop' || forScreenSize === 'all' ? 'flex' : 'none';
}, _baseReactComponents.Icon, ToggleCopy);

var FilterHeading = (0, _styledComponents["default"])(_baseReactComponents.Copy).withConfig({
  displayName: "FilterHeading",
  componentId: "sc-4j5vy9-2"
})(["display:flex;flex-direction:row;align-items:center;justify-content:flex-end;& > ", "{margin-left:8px;}"], _baseReactComponents.Icon);
var FooterButton = (0, _styledComponents["default"])(_baseReactComponents.Button).withConfig({
  displayName: "FooterButton",
  componentId: "sc-4j5vy9-3"
})(["justify-content:center;"]);

var FilterFooter = _styledComponents["default"].div.withConfig({
  displayName: "FilterFooter",
  componentId: "sc-4j5vy9-4"
})(["display:flex;flex-direction:row;align-items:center;justify-content:center;padding:0 48px;& > ", "{flex:1 1 auto;}& > ", ":not(:last-child){margin-right:16px;}"], FooterButton, FooterButton);

var FilterContainer = _styledComponents["default"].div.withConfig({
  displayName: "FilterContainer",
  componentId: "sc-4j5vy9-5"
})(["display:flex;flex-direction:column;align-items:stretch;justify-content:flex-start;overflow:auto;padding:0 48px;& > ", "{padding:24px 0;}& > ", ":first-child{padding:0 0 24px 0;}& > ", ":not(:last-child){border-style:solid;border-width:0 0 1px 0;border-color:", ";}"], _filterCategory.FilterCategory, _filterCategory.FilterCategory, _filterCategory.FilterCategory, function (_ref6) {
  var theme = _ref6.theme;
  return theme.scuttleGray200;
});

var ControlLayout = _styledComponents["default"].div.withConfig({
  displayName: "ControlLayout",
  componentId: "sc-4j5vy9-6"
})(["display:flex;flex-direction:column;align-items:stretch;justify-content:flex-start;width:100%;height:100%;overflow:hidden;background:", ";pointer-events:auto;& > ", "{flex:0 0 auto;align-self:center;margin-bottom:24px;}& > ", "{flex:1 0 0;align-self:stretch;}& > ", "{flex:0 0 auto;margin:24px 0;}"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.white;
}, FilterHeading, FilterContainer, FilterFooter);

var ModalScreen = (0, _styledComponents["default"])(_screen.Screen).withConfig({
  displayName: "ModalScreen",
  componentId: "sc-4j5vy9-7"
})(["display:", ";@media screen and (", "){display:", ";}"], function (_ref8) {
  var forScreenSize = _ref8.forScreenSize;
  return forScreenSize === 'mobile' || forScreenSize === 'all' ? 'flex' : 'none';
}, function (_ref9) {
  var forLargerThanPhone = _ref9.theme.forLargerThanPhone;
  return forLargerThanPhone;
}, function (_ref10) {
  var forScreenSize = _ref10.forScreenSize;
  return forScreenSize === 'desktop' || forScreenSize === 'all' ? 'flex' : 'none';
});
var FullScreenFilterToggle = (0, _styledComponents["default"])((0, _styledComponents.withTheme)(function (_ref11) {
  var _ref11$mobileToggleLa = _ref11.mobileToggleLabel,
      mobileToggleLabel = _ref11$mobileToggleLa === void 0 ? 'Filter Results' : _ref11$mobileToggleLa,
      _ref11$onClick = _ref11.onClick,
      _onClick = _ref11$onClick === void 0 ? function () {} : _ref11$onClick,
      _ref11$forScreenSize = _ref11.forScreenSize,
      forScreenSize = _ref11$forScreenSize === void 0 ? 'all' : _ref11$forScreenSize,
      theme = _ref11.theme,
      className = _ref11.className;

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Toggle, {
    forScreenSize: forScreenSize,
    onClick: function onClick(e) {
      return _onClick(e);
    },
    className: className,
    "data-testid": "full-screen-filter:toggle",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Icon, {
      name: "tech/filter",
      color: theme.bubbleBlue500,
      height: "24",
      width: "24"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(ToggleCopy, {
      bold: true,
      size: "lg",
      children: mobileToggleLabel
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Icon, {
      name: "actions/carrot-right",
      color: theme.bubbleBlue500,
      height: "24",
      width: "24"
    })]
  });
})).withConfig({
  displayName: "FullScreenFilterToggle",
  componentId: "sc-4j5vy9-8"
})([""]);
exports.FullScreenFilterToggle = FullScreenFilterToggle;
FullScreenFilterToggle.displayName = 'FullScreenFilterToggle';
var FullScreenFilter = (0, _styledComponents["default"])((0, _styledComponents.withTheme)(function (_ref12) {
  var _ref12$filters = _ref12.filters,
      filters = _ref12$filters === void 0 ? [] : _ref12$filters,
      _ref12$activeFilters = _ref12.activeFilters,
      activeFilters = _ref12$activeFilters === void 0 ? {} : _ref12$activeFilters,
      _ref12$multiSelectFil = _ref12.multiSelectFilters,
      multiSelectFilters = _ref12$multiSelectFil === void 0 ? [] : _ref12$multiSelectFil,
      _ref12$onChange = _ref12.onChange,
      onChange = _ref12$onChange === void 0 ? function () {} : _ref12$onChange,
      _ref12$onClose = _ref12.onClose,
      onClose = _ref12$onClose === void 0 ? function () {} : _ref12$onClose,
      _ref12$filterHeading = _ref12.filterHeading,
      filterHeading = _ref12$filterHeading === void 0 ? 'Filters' : _ref12$filterHeading,
      _ref12$filterHeadingI = _ref12.filterHeadingIcon,
      filterHeadingIcon = _ref12$filterHeadingI === void 0 ? 'tech/filter' : _ref12$filterHeadingI,
      _ref12$filterResetTex = _ref12.filterResetText,
      filterResetText = _ref12$filterResetTex === void 0 ? 'View All' : _ref12$filterResetTex,
      _ref12$filterResetAll = _ref12.filterResetAllText,
      filterResetAllText = _ref12$filterResetAll === void 0 ? 'Clear All' : _ref12$filterResetAll,
      _ref12$filterApplyTex = _ref12.filterApplyText,
      filterApplyText = _ref12$filterApplyTex === void 0 ? 'Apply Filters' : _ref12$filterApplyTex,
      _ref12$forScreenSize = _ref12.forScreenSize,
      forScreenSize = _ref12$forScreenSize === void 0 ? 'all' : _ref12$forScreenSize,
      className = _ref12.className,
      theme = _ref12.theme;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ModalScreen, {
    forScreenSize: forScreenSize,
    onClose: onClose,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(ControlLayout, {
      className: className,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(FilterHeading, {
        bold: true,
        "data-testid": "full-screen-filter:filter-by",
        children: [filterHeading, /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Icon, {
          name: filterHeadingIcon,
          color: theme.scuttleGray600,
          height: "24",
          width: "24"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(FilterContainer, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_filterIterator.FilterIterator, {
          filters: filters,
          activeFilters: activeFilters,
          multiSelectFilters: multiSelectFilters,
          Filter: function Filter(_ref13) {
            var name = _ref13.name,
                options = _ref13.options,
                isSingleOption = _ref13.isSingleOption,
                isInUse = _ref13.isInUse,
                multiSelectEnabled = _ref13.multiSelectEnabled;
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_filterCategory.FilterCategory, {
              name: name,
              options: options,
              onChange: onChange,
              activeFilters: activeFilters,
              isSingleOption: isSingleOption,
              isInUse: isInUse,
              multiSelectEnabled: multiSelectEnabled,
              filterResetText: filterResetText
            }, name);
          }
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(FilterFooter, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(FooterButton, {
          variation: "outline",
          size: "large",
          onClick: function onClick() {
            return onChange({});
          },
          "data-testid": "full-screen-filter:reset-all-button",
          children: filterResetAllText
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(FooterButton, {
          size: "large",
          onClick: onClose,
          "data-testid": "full-screen-filter:apply-filters-button",
          children: filterApplyText
        })]
      })]
    })
  });
})).withConfig({
  displayName: "FullScreenFilter",
  componentId: "sc-4j5vy9-9"
})([""]);
exports.FullScreenFilter = FullScreenFilter;
FullScreenFilter.displayName = 'FullScreenFilter';
//# sourceMappingURL=index.js.map